import { Dispatch, SetStateAction } from 'react';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Button } from '../../../components/common/Button/Button';
import { Icon, IconApproveNFT } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2, P3 } from '../../../styles/FontStyles';
import { useDisconnect } from 'wagmi';

interface Step6Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  setWalletAddress: Dispatch<SetStateAction<string | undefined>>;
}

export const Step6 = ({ setWithdrawStep, setWalletAddress }: Step6Props) => {
  const { disconnect } = useDisconnect();
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20' style={{ cursor: 'pointer' }}>
              <IconApproveNFT />
            </Icon>
          </Flexed>

          <P2 bold center mb='40'>
            Approve the withdrawal transaction.
          </P2>

          <Button
            w='350px'
            mr='12'
            onClick={() => {
              setWithdrawStep(WithdrawStepsEnum.CONNECT_WALLET);
              setWalletAddress('');
              disconnect();
            }}>
            Approve
          </Button>
        </Flexed>
      </Box>
    </>
  );
};
